import ServiceCRUD from '../../../services/ServiceCRUD';
import { apiCase as http } from '../../../http';
import { apiCrm } from '../../../http';
class StatusNotificationMessagesService extends ServiceCRUD {
  constructor() {
    super('/protocol-status-email-message');
  }

  async getEmailMessageByRecordType(recordTypeId) {
    const response = await http.get(
      `/protocol-status-email-message/record-type/${recordTypeId}`
    );
    return response?.data;
  }

  async getRecordTypesProtocol() {
    const response = await http.get(`/record-type`);
    return response?.data?.recordTypes?.flatMap((recordType) => {
      if (recordType?.entity === 'PROTOCOL') {
        return [
          {
            value: recordType.id,
            label: recordType.name
          }
        ];
      }
      return [];
    });
  }
  async getFields(entityName, params) {
    const result = await apiCrm.get(`custom-field/protocol`, {
      params
    });
    return result.data.data;
  }
}

export default new StatusNotificationMessagesService();
